export const MAX_PAGE_WIDTH_PX = 1080
export const MIN_PAGE_WIDTH_PX = 720
export const PAGE_GUTTER_PX = 32
export const MIN_DESKTOP_CONTENT_WIDTH_PX = 328
